import styled from 'styled-components'

export const StPlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
  margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space5};
`

export const StCheckboxContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.Components.Conversational.Border};
  border-radius: 4px;
`
